<template>
  <div>
    <el-dialog
      :visible.sync="visible"
      :modal="false"
      :show-close="false"
      :close-on-click-modal="false"
      :style="{
        position: 'fixed',
        top: position.top + 'px',
        left: position.left + 'px',
        width: size.width + 'px',
        height: size.height + 'px',
        overflow: 'hidden',
        'box-shadow': 'rgba(0, 0, 0, 0.08) 0px 3px 18px 0px',
      }"
      @opened="handleOpend"
      custom-class="custom-dialog">
      <!-- 自定义标题栏（用于拖拽） -->
      <div class="dialog-header" slot="title" @mousedown="startDrag">
        <div class="draggable-title text-ellipsis">{{ title }}</div>
        <div class="dialog-close">
          <img src="./show.png" alt="" :style="{ transform: show ? 'rotate(180deg)' : 'rotate(0deg)' }" @click="handleShow" />
          <img src="./close.png" alt="" @click.stop="handleClose" />
        </div>
      </div>
      <div v-show="show" class="dialog-body" :style="{ height: size.height - 64 + 'px', overflow: 'hidden' }" v-loading="loading" element-loading-text="正在加载页面，请稍候！">
        <iframe id="iframePreview" style="width: 100%; height: 100%" :src="src" @load="onIframeLoad" frameborder="no"></iframe>
      </div>
      <!-- 缩放手柄（右下角） -->
      <div v-if="show" class="resize-r-b" @mousedown="(e) => startResize(e, 'r-b')"></div>
      <!-- 缩放手柄（左下角） -->
      <div v-if="show" class="resize-l-b" @mousedown="(e) => startResize(e, 'l-b')"></div>
      <!-- 缩放手柄（右上角） -->
      <div v-if="show" class="resize-r-t" @mousedown="(e) => startResize(e, 'r-t')"></div>
      <!-- 缩放手柄（左上角） -->
      <div v-if="show" class="resize-l-t" @mousedown="(e) => startResize(e, 'l-t')"></div>
    </el-dialog>
    <div class="dialog-bg-center" v-if="this.isDragging || this.isResizing"></div>
  </div>
</template>

<script>
import { getConfigKey } from '@/api/courses.js';
import { Base64 } from 'js-base64';
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    path: {
      type: String,
      default: '',
    },
    index: {
      type: [String, Number],
    },
    indexFile: {
      type: [String, Number]
    }
  },
  data() {
    return {
      position: { top: 100, left: window.innerWidth / 2 - 250 }, // 弹窗位置
      size: { width: 600, height: 400 }, // 弹窗大小
      isDragging: false, // 是否拖动
      isResizing: false, // 是否缩放
      startX: 0,
      startY: 0,
      startTop: 0,
      startLeft: 0,
      startWidth: 0,
      startHeight: 0,
      previewurl: null,
      src: null,
      loading: false,
      show: true,
      showHeight: null, // 修改弹窗时，记录弹窗高度
      resizeType: null, // 缩放类型
    };
  },
  mounted() {
    document.addEventListener('mousemove', this.handleMouseMove);
    document.addEventListener('mouseup', this.handleMouseUp);
  },
  beforeDestroy() {
    document.removeEventListener('mousemove', this.handleMouseMove);
    document.removeEventListener('mouseup', this.handleMouseUp);
  },
  methods: {
    /**
     * 弹窗拖动
     */
    startDrag(e) {
      this.isDragging = true;
      this.startX = e.clientX;
      this.startY = e.clientY;
      this.startTop = this.position.top;
      this.startLeft = this.position.left;
      e.preventDefault();
    },
    /**
     * 缩放手柄
     */
    startResize(e, type) {
      this.resizeType = type;
      this.isResizing = true;
      this.startX = e.clientX;
      this.startY = e.clientY;
      this.startWidth = this.size.width;
      this.startHeight = this.size.height;
      this.startTop = this.position.top;
      this.startLeft = this.position.left;
      e.preventDefault();
    },
    handleMouseMove(e) {
      // 拖动
      if (this.isDragging) {
        const left = this.startLeft + (e.clientX - this.startX);
        const top = this.startTop + (e.clientY - this.startY);

        // 获取当前窗口尺寸
        const winWidth = window.innerWidth;
        const winHeight = window.innerHeight;

        // 弹窗宽高（使用当前 size，因为拖动时 size 可能已变）
        const dialogWidth = this.size.width;
        const dialogHeight = this.size.height;

        // 限制 left：不能小于 0，也不能让右边超出窗口
        const maxLeft = winWidth - dialogWidth;
        this.position.left = Math.max(0, Math.min(maxLeft, left));

        // 限制 top：不能小于 0，也不能让底边超出窗口
        const maxTop = winHeight - dialogHeight;
        this.position.top = Math.max(0, Math.min(maxTop, top));
      }
      // 缩放
      if (this.isResizing) {
        const winWidth = window.innerWidth;
        const winHeight = window.innerHeight;
        const minWidth = 300;
        const minHeight = 200;

        let newLeft = this.startLeft;
        let newTop = this.startTop;
        let newWidth = this.startWidth;
        let newHeight = this.startHeight;

        // 根据角落类型计算新尺寸和位置
        switch (this.resizeType) {
          case 'r-b': // 右下
            newWidth = this.startWidth + (e.clientX - this.startX);
            newHeight = this.startHeight + (e.clientY - this.startY);
            break;

          case 'l-b': // 左下
            newWidth = this.startWidth - (e.clientX - this.startX);
            newHeight = this.startHeight + (e.clientY - this.startY);
            newLeft = this.startLeft + (e.clientX - this.startX);
            break;

          case 'l-t': // 左上
            newWidth = this.startWidth - (e.clientX - this.startX);
            newHeight = this.startHeight - (e.clientY - this.startY);
            newLeft = this.startLeft + (e.clientX - this.startX);
            newTop = this.startTop + (e.clientY - this.startY);
            break;

          case 'r-t': // 右上
            newWidth = this.startWidth + (e.clientX - this.startX);
            newHeight = this.startHeight - (e.clientY - this.startY);
            newTop = this.startTop + (e.clientY - this.startY);
            break;
        }

        // 应用最小尺寸限制
        newWidth = Math.max(minWidth, newWidth);
        newHeight = Math.max(minHeight, newHeight);

        // 边界检测：确保弹窗不超出视口
        // 1. 左边界 ≥ 0
        newLeft = Math.max(0, newLeft);
        // 2. 上边界 ≥ 0
        newTop = Math.max(0, newTop);
        // 3. 右边界 ≤ window.innerWidth
        if (newLeft + newWidth > winWidth) {
          newWidth = winWidth - newLeft; // 自动缩小宽度
          newWidth = Math.max(minWidth, newWidth); // 仍需满足最小宽
        }
        // 4. 下边界 ≤ window.innerHeight
        if (newTop + newHeight > winHeight) {
          newHeight = winHeight - newTop;
          newHeight = Math.max(minHeight, newHeight);
        }

        // 更新数据
        this.position.left = newLeft;
        this.position.top = newTop;
        this.size.width = newWidth;
        this.size.height = newHeight;
      }
    },
    /**
     * 鼠标松开
     */
    handleMouseUp() {
      this.isDragging = false;
      this.isResizing = false;
    },
    /**
     * 关闭弹窗
     */
    handleClose() {
      this.src = null;
      this.$emit('closeDialog', this.index, this.indexFile);
    },
    /**
     * 弹窗缩放
     */
    handleShow() {
      if (this.show) {
        this.showHeight = this.size.height;
      }
      this.show = !this.show;
      this.size.height = this.show ? this.showHeight : 64;
    },

    /**
     * 弹窗打开后 显示iframe
     */
    handleOpend() {
      getConfigKey({
        configKey: 'previewurl',
      }).then((res) => {
        if (res.code === 200 && res.rows.length > 0) {
          this.previewurl = res.rows[0].configValue;
          this.loadIframe();
        } else {
          this.$modal.alertWarning('请先配置预览地址');
        }
      });
    },
    loadIframe() {
      const iframeId = '#iframePreview'.replace(/\//g, '\\/');
      const iframe = document.querySelector(iframeId);
      this.src = this.previewurl + '/onlinePreview?url=' + encodeURIComponent(Base64.encode(this.path));
      // iframe页面loading控制
      if (iframe.attachEvent) {
        this.loading = true;
        iframe.attachEvent('onload', () => {
          this.loading = false;
        });
      } else {
        this.loading = true;
        iframe.onload = () => {
          this.loading = false;
        };
      }
    },
    /**
     * iframe 加载完成
     */
    onIframeLoad() {
      this.loading = false;
    }
  },
};
</script>

<style lang="scss" scoped>
.custom-dialog {
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.dialog-header {
  padding: 12px 10px 12px 20px;
  background-color: #ce8137;
  color: #ffffff;
  border-radius: 8px 8px 0px 0px;
  cursor: move;
  display: flex;
  justify-content: space-between;
  align-items: center;
  overflow: hidden;
}
.dialog-body {
  overflow: auto;
}
.resize-r-b {
  cursor: se-resize;
  position: absolute;
  bottom: 0;
  right: 0;
  width: 12px;
  height: 12px;
}
.resize-l-b {
  cursor: sw-resize;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 12px;
  height: 12px;
}
.resize-r-t {
  cursor: ne-resize;
  position: absolute;
  top: 0;
  right: 0;
  width: 12px;
  height: 12px;
}
.resize-l-t {
  cursor: nw-resize;
  position: absolute;
  top: 0;
  left: 0;
  width: 12px;
  height: 12px;
}
.dialog-close {
  width: 80px;
  cursor: pointer;
  display: flex;
}
::v-deep .el-dialog {
  margin: 0 !important;
  max-height: calc(100vh - 20px);
  width: 100%;
  border-radius: 8px 8px 0px 0px;
  overflow: hidden;
}
::v-deep .el-dialog__header {
  padding: 0;
}
::v-deep .el-dialog__body {
  padding: 0;
}

.draggable-title {
  flex: 1;
}

.dialog-bg-center {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
}
</style>
